<template>
    <div class="section text-center mt-4" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <template v-if="!loading">
        <div class="section pt-2">
            <div class="vr-hero">
                <div class="vr-hero-icon"><ion-icon name="people-outline"></ion-icon></div>
                <h3 class="vr-hero-title" v-html="event_details.name"></h3>
                <div class="vr-hero-meta">
                    <span class="vr-hero-chip" v-if="event_details.place">
                        <ion-icon name="location-outline"></ion-icon> {{ event_details.place }}
                    </span>
                    <span class="vr-hero-chip" v-if="event_details.date">
                        <ion-icon name="calendar-outline"></ion-icon> {{ event_details.date }}
                    </span>
                </div>
            </div>
        </div>

        <div class="section pt-0 mt-2" v-if="volunteer_message">
            <div class="vr-notice">{{ volunteer_message }}</div>
        </div>

        <div class="section pt-0 mt-2">
            <div class="vr-card">
                <Form @submit="updateVolunteer" :validation-schema="schema">
                    <div class="form-group basic" v-if="member_list.length > 1">
                        <label class="vr-label">Member</label>
                        <div class="input-wrapper">
                            <Field as="select" class="form-control custom-select" v-model="member_id" name="member_id"
                                id="select4" @change="changeMember">
                                <option value>--Select--</option>
                                <option v-for="member in member_list" v-bind:key="member.id" v-bind:value="member.id">
                                    {{ member.name }}
                                </option>
                            </Field>
                            <ErrorMessage name="member_id" class="error-feedback" />
                        </div>
                    </div>

                    <div class="form-group basic">
                        <label class="vr-label">വളണ്ടിയർ ആകാൻ തയ്യാറാണോ?</label>
                        <div class="input-wrapper">
                            <Field as="select" class="form-control custom-select" v-model="volunteer_ready"
                                name="volunteer_ready" id="select5" @change="readyChange">
                                <option value="Y">അതെ</option>
                                <option value="N">അല്ല</option>
                            </Field>
                            <ErrorMessage name="volunteer_ready" class="error-feedback" />
                        </div>
                    </div>

                    <template v-if="volunteer_ready == 'Y'">
                        <div class="form-group basic">
                            <label class="vr-label">വളണ്ടിയർ ആകാൻ താല്പര്യമുള്ള വകുപ്പ് തിരഞ്ഞെടുക്കുക.</label>
                            <div class="input-wrapper">
                                <Field as="select" class="form-control custom-select" v-model="volunteer_department"
                                    name="volunteer_department" id="select6" @change="changeDep">
                                    <option value>--Select--</option>
                                    <option v-for="department in department_list" v-bind:key="department"
                                        v-bind:value="department.id">
                                        {{ department.name }}
                                    </option>
                                </Field>
                            </div>
                            <span id="volunteer_department" class="error-feedback">{{
                                volunteer_department_message
                            }}</span>
                        </div>

                        <div class="form-group basic">
                            <label class="vr-label">നിങ്ങൾക്ക് വളണ്ടിയർ ആകാൻ കഴിയുന്ന ദിവസങ്ങൾ ഏതൊക്കെ ?</label>
                            <div class="vr-tile-group">
                                <label class="vr-tile" v-for="item in time_list" :key="item"
                                    :class="{ selected: volunteer_time.includes(item) }">
                                    <Field class="vr-tile-input" name="volunteer_time" type="checkbox" :value="item"
                                        v-model="volunteer_time" />
                                    <span>{{ item }}</span>
                                </label>
                            </div>
                            <span id="volunteer_time" class="error-feedback">{{ volunteer_time_message }}</span>
                        </div>

                        <div class="form-group basic">
                            <label class="vr-label">താങ്കൾക്കുള്ള ശാരീരിക പ്രയാസങ്ങൾ?</label>
                            <div class="vr-tile-group">
                                <label class="vr-tile" v-for="item in health_status_list" :key="item"
                                    :class="{ selected: health_status.includes(item) }">
                                    <Field class="vr-tile-input" name="health_status" type="checkbox" :value="item"
                                        v-model="health_status" />
                                    <span>{{ item }}</span>
                                </label>
                            </div>
                            <span id="health_status" class="error-feedback">{{ health_status_message }}</span>
                        </div>
                    </template>

                    <button type="submit" class="btn btn-primary btn-block btn-lg mt-3" :disabled="btn_loading"
                        v-if="permissions.update_volunteer">
                        <span v-show="loading" class="spinner-border spinner-border-sm me-1"></span>
                        <span>Save</span>
                    </button>
                    <button type="button" class="btn btn-primary btn-block btn-lg mt-3" v-if="!permissions.update_volunteer">
                        Close
                    </button>
                </Form>
            </div>
        </div>

        <div class="section pt-0 mt-2" v-if="showAddForm">
            <div class="vr-card">
                <h5 class="vr-card-title">Add New Volunteer</h5>
                <Form @submit="updateVolunteer" :validation-schema="schema">
                    <div class="form-group basic">
                        <label class="vr-label">Member</label>
                        <div class="input-wrapper">
                            <v-select label="text" :filterable="true" v-model="new_member" :value="new_member"
                                :options="member_list" @input="getTextList($event.target.value, 0)">
                                <template>
                                    type to search...
                                </template>
                                <template>
                                    <div class="d-center">
                                        {{ new_member.name }}
                                    </div>
                                </template>
                            </v-select>
                            <ErrorMessage name="member" class="error-feedback" />
                        </div>
                        <div class="vr-input-info" v-if="new_member">
                            Mobile: {{ new_member.country_code }} {{ new_member.mobile }}
                        </div>
                    </div>

                    <div class="form-group basic">
                        <label class="vr-label">വളണ്ടിയർ ആകാൻ താല്പര്യമുള്ള വകുപ്പ് തിരഞ്ഞെടുക്കുക.</label>
                        <div class="input-wrapper">
                            <Field as="select" class="form-control custom-select" v-model="new_volunteer_department"
                                name="volunteer_department" id="select7" @change="changeDep">
                                <option value>--Select--</option>
                                <option v-for="department in department_list" v-bind:key="department"
                                    v-bind:value="department.id">
                                    {{ department.name }}
                                </option>
                            </Field>
                        </div>
                        <span id="volunteer_department" class="error-feedback">{{
                            volunteer_department_message
                        }}</span>
                    </div>

                    <div class="form-group basic">
                        <label class="vr-label">നിങ്ങൾക്ക് വളണ്ടിയർ ആകാൻ കഴിയുന്ന ദിവസങ്ങൾ ഏതൊക്കെ ?</label>
                        <div class="vr-tile-group">
                            <label class="vr-tile" v-for="item in time_list" :key="item"
                                :class="{ selected: new_volunteer_time.includes(item) }">
                                <Field class="vr-tile-input" name="volunteer_time" type="checkbox" :value="item"
                                    v-model="new_volunteer_time" />
                                <span>{{ item }}</span>
                            </label>
                        </div>
                        <span id="volunteer_time" class="error-feedback">{{ volunteer_time_message }}</span>
                    </div>

                    <div class="form-group basic">
                        <label class="vr-label">താങ്കൾക്കുള്ള ശാരീരിക പ്രയാസങ്ങൾ?</label>
                        <div class="vr-tile-group">
                            <label class="vr-tile" v-for="item in health_status_list" :key="item"
                                :class="{ selected: new_health_status.includes(item) }">
                                <Field class="vr-tile-input" name="health_status" type="checkbox" :value="item"
                                    v-model="new_health_status" />
                                <span>{{ item }}</span>
                            </label>
                        </div>
                        <span id="health_status" class="error-feedback">{{ health_status_message }}</span>
                    </div>

                    <div class="d-flex gap-2 mt-3">
                        <button type="button" class="btn btn-secondary btn-lg flex-fill" @click="showAddForm = false">
                            Cancel
                        </button>
                        <button type="submit" class="btn btn-primary btn-lg flex-fill" :disabled="btn_loading">
                            <span v-show="loading" class="spinner-border spinner-border-sm me-1"></span>
                            <span>Save</span>
                        </button>
                    </div>
                </Form>
            </div>
        </div>

        <div class="section pt-0 mt-2" v-if="currentUser.user_level <= 3">
            <div class="vr-card">
                <h5 class="vr-card-title">Volunteer List</h5>
                <div class="table-responsive vr-table-wrapper">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 44px;">SL</th>
                                <th scope="col">Name</th>
                                <th scope="col">Mobile</th>
                                <th scope="col">Unit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(volunteer, index) in volunteer_list" :key="volunteer.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ volunteer.member ? volunteer.member.name : volunteer.name }}</td>
                                <td>{{ volunteer.member ? volunteer.member.mobile : volunteer.mobile }}</td>
                                <td>{{ volunteer.member && volunteer.member.unit_name ? volunteer.member.unit_name : (volunteer.unit_name || '') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="section pt-0 mt-2 pb-3" v-if="currentUser.user_level <= 3 && !showAddForm">
            <button type="button" class="btn btn-primary btn-block btn-lg" @click="showAddForm = true">
                <ion-icon name="person-add-outline" class="me-1"></ion-icon> Add Volunteer
            </button>
        </div>
    </template>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import {
    Form,
    Field,
    ErrorMessage
} from "vee-validate";
import $ from "jquery";
import * as yup from "yup";
import UserService from "../../../services/user.service";
import AlertModel from "./../../layouts/AlertModel.vue";
import DialogModel from "./../../layouts/DialogModel.vue";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    name: "Admin List",
    props: {
        unit_id: null,
    },
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel,
        DialogModel,
        vSelect
    },
    data() {
        const schema = yup.object().shape({
            volunteer_department: yup.string().required("ഫിൽ ചെയ്യുക"),
        });
        return {
            showAddForm: false,
            new_member: null,
            new_member_id: "",
            new_volunteer_department: "",
            new_volunteer_time: [],
            new_health_status: [],
            new_volunteer_tshirt_size: "",
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],

            loading: false,
            btn_loading: false,
            schema,
            event_details: {},
            permissions: [],
            volunteer_message: "",
            volunteer_department: "",
            volunteer_ready: "",
            volunteer_tshirt_size : "",
            department_list: [],
            member_list: [],
            member_id: "",
            volunteer_department_message: "",
            volunteer_time_message: "",
            time_list: [],
            tshirt_list: [],
            volunteer_time: [],
            health_status: [],
            health_status_list: [],
            health_status_message: "",
            volunteer_list: [],
            member_unit: "",
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        }
        this.user_level = parseInt(this.$route.params.sub_level) || 3;
        this.$root.updateParent("Volunteer Registration");
        this.getEventDetails();
        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },

    methods: {
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                unit_id: this.$route.params.id,
                user_level: this.currentUser.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                        if (event && event.id) {
                            this.new_member_id = event.id;
                            this.new_member = {
                                ...event,
                                unit: event.unit // Store unit from member selection
                            };
                        }
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        changeMember(member) {
            if (member == 4 || member == 6) {
                this.getComboboxValues(this.event_details.event_capital + "_VDL");
            } else {
                this.getComboboxValues(this.event_details.event_capital + "_VDG");
            }
        },
        getEventDetails() {
            this.loading = true;
            let data = {
                slug: this.$route.params.slug,
                event_id: this.$route.params.event_id,
                page: "volunteer",
            };
            UserService.authPostRequest(`get-event-details`, data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.event_details = response.data.data.event_details;
                        this.volunteer_list = response.data.data.volunteer_list || [];
                        this.time_list = response.data.data.volunteer_times;
                        this.tshirt_list = response.data.data.volunteer_t_shirt;
                        this.health_status_list = response.data.data.volunteer_health_status;
                        this.permissions = response.data.data.permissions;
                        this.volunteer_message = response.data.data.message;
                        this.member_list = response.data.data.members;
                        this.department_list = response.data.data.departments || [];
                        
                        if (response.data.data.volunteer) {
                            this.member_id = response.data.data.volunteer.member_id;
                            this.volunteer_ready = "Y";
                            this.volunteer_department = response.data.data.volunteer.department_id;
                            this.volunteer_time = JSON.parse(response.data.data.volunteer.time);
                            this.health_status = JSON.parse(response.data.data.volunteer.health_status);
                            this.volunteer_tshirt_size = response.data.data.volunteer.volunteer_tshirt_size;
                        }
                        if (this.member_list.length == 1) {
                            this.member_id = this.member_list[0].id;
                            let wing = this.member_list[0].wing;
                            if (wing == 4 || wing == 6) {
                                this.getComboboxValues(this.event_details.event_capital + "_VDL");
                            } else {
                                this.getComboboxValues(this.event_details.event_capital + "_VDG");
                            }
                        } else {
                            this.member_list.forEach((element) => {
                                if (element.mobileSelf == "Y") {
                                    this.member_id = element.id;
                                    let wing = element.wing;
                                    if (wing == 4 || wing == 6) {
                                        this.getComboboxValues(this.event_details.event_capital + "_VDL");
                                    } else {
                                        this.getComboboxValues(this.event_details.event_capital + "_VDG");
                                    }
                                }
                            });
                        }
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id,
                member_id: this.member_id,
            };
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case this.event_details.event_capital + "_VDL":
                            this.department_list = response.data.data.list.options;
                            break;
                        case this.event_details.event_capital + "_VDG":
                            this.department_list = response.data.data.list.options;
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        changeDep() {
            this.volunteer_department_message = "";
        },
        updateVolunteer() {
            if (this.showAddForm) {
                // Handle Add Volunteer form submission
                if (!this.new_member) {
                    this.alert_type = 'Warning';
                    this.alert_message = 'Please select a member';
                    this.$refs.alert_model.openModel();
                    return;
                }
                
                this.loading = true;
                let formData = {
                    member_id: this.new_member.id,
                    event_id: this.$route.params.event_id,
                    volunteer_ready: "Y",
                    volunteer_department: this.new_volunteer_department,
                    volunteer_time: this.new_volunteer_time,
                    health_status: this.new_health_status,
                    volunteer_tshirt_size: this.new_volunteer_tshirt_size,
                    add_registration: true
                };

                UserService.authPostRequest('store-event-volunteer', formData).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.status == 'success') {
                            this.alert_type = 'Success';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                            
                            this.new_member = null;
                            this.new_volunteer_department = '';
                            this.new_volunteer_time = [];
                            this.new_health_status = [];
                            this.new_volunteer_tshirt_size = '';
                            this.getEventDetails();
                            this.showAddForm = false;
                        } else if (response.data.status == 'warning') {
                            this.alert_type = 'Warning';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        } else {
                            this.alert_type = 'Error';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = (error.response && 
                            error.response.data && 
                            error.response.data.message) || 
                            'Failed to save volunteer';
                        this.$refs.alert_model.openModel();
                    }
                );
            } else {
                // Handle main form submission
                this.loading = true;
                let formData = {
                    member_id: this.member_id,
                    event_id: this.$route.params.event_id,
                    volunteer_ready: "Y",
                    volunteer_department: this.volunteer_department,
                    volunteer_time: this.volunteer_time,
                    health_status: this.health_status,
                    volunteer_tshirt_size: this.volunteer_tshirt_size
                };

                UserService.authPostRequest('store-event-volunteer', formData).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.status == 'success') {
                            this.alert_type = 'Success';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                            this.getEventDetails();
                        } else if (response.data.status == 'warning') {
                            this.alert_type = 'Warning';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        } else {
                            this.alert_type = 'Error';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = (error.response && 
                            error.response.data && 
                            error.response.data.message) || 
                            'Failed to save volunteer';
                        this.$refs.alert_model.openModel();
                    }
                );
            }
        },
        getDepartmentName(department_id) {
            const department = this.department_list.find(dept => dept.id === department_id);
            return department ? department.name : '';
        },
    },
};
</script>

<style scoped>
.error-feedback {
    color: #d9534f;
    font-size: 12px;
    display: block;
    margin-top: 2px;
}

/* Hero */
.vr-hero {
    background: #fff;
    border-radius: 14px;
    padding: 22px 18px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.vr-hero-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #eef2ff;
    color: #1a418c;
    font-size: 26px;
    margin-bottom: 10px;
}

.vr-hero-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1a418c;
    margin-bottom: 8px;
    word-break: break-word;
}

.vr-hero-meta {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
}

.vr-hero-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #27173e;
    background: #f5f6fa;
    border-radius: 20px;
    padding: 5px 12px;
}

/* Notice */
.vr-notice {
    background: #fff8e6;
    border: 1px solid #ffe6a0;
    color: #7a5a00;
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 0.9rem;
    line-height: 1.4;
}

/* Cards */
.vr-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.vr-card-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1a418c;
    margin-bottom: 14px;
}

.vr-label {
    font-size: 14px;
    font-weight: 700;
    color: #1a418c;
    display: block;
    margin-bottom: 5px;
    line-height: 1.35;
}

.vr-input-info {
    font-size: 12px;
    color: #6c757d;
    margin-top: 4px;
}

/* Checkbox tile groups (replaces bare inline checkboxes) */
.vr-tile-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 4px;
}

.vr-tile {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 8px 14px;
    border: 1px solid #ced4da;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    flex: 1 1 calc(50% - 10px);
    font-size: 14px;
    color: #212529;
}

.vr-tile.selected {
    border-color: #0d6efd;
    background: #eef4ff;
    color: #1a418c;
    font-weight: 600;
}

.vr-tile-input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
    pointer-events: none;
}

/* Volunteer list table */
.vr-table-wrapper {
    max-height: 260px;
    overflow-y: auto;
    border: 1px solid #eee;
    border-radius: 8px;
}

.vr-table-wrapper .table {
    margin-bottom: 0;
    font-size: 13px;
}

.vr-table-wrapper .table thead th {
    background: #fff;
    border-bottom: 2px solid #dee2e6;
    position: sticky;
    top: 0;
    z-index: 1;
}

.vr-table-wrapper .table tbody {
    border-top: none;
}

.vr-table-wrapper .table td,
.vr-table-wrapper .table th {
    padding: 10px;
    vertical-align: middle;
}
</style>
